import React, { useRef, useState } from 'react'
import Box from '@material-ui/core/Box'
import Button from '@material-ui/core/Button'
import IconButton from '@material-ui/core/IconButton'
import Menu from '@material-ui/core/Menu'
import MenuItem from '@material-ui/core/MenuItem'
import Typography from '@material-ui/core/Typography'
import AddOutlinedIcon from '@material-ui/icons/AddOutlined'
import ArrowDropDownIcon from '@material-ui/icons/ArrowDropDown'
import { makeStyles } from '@material-ui/core/styles'
import OneTimeSlotDialog from './one-time-slot-dialog'

const useStyles = makeStyles(theme => ({
  menuPaper: {
    marginTop: theme.spacing(0.5),
    minWidth: 220,
  },
  item: {
    padding: theme.spacing(1.25, 2),
    gap: theme.spacing(1.5),
  },
  dot: {
    width: 14,
    height: 14,
    borderRadius: 3,
    flexShrink: 0,
    boxSizing: 'border-box',
  },
  dotOpen: {
    backgroundColor: '#FFFFFF',
    backgroundImage:
      'repeating-linear-gradient(135deg, #E3F2FD 0 4px, #FFFFFF 4px 8px)',
    border: '1px solid #90CAF9',
  },
  dotBlocked: {
    backgroundColor: '#F5F5F5',
    border: '1px solid #BDBDBD',
  },
  itemText: {
    display: 'flex',
    flexDirection: 'column',
  },
  itemTitle: {
    fontWeight: 500,
    lineHeight: 1.3,
  },
  itemSubtitle: {
    color: theme.palette.text.secondary,
    fontSize: 12,
    lineHeight: 1.3,
  },
}))

const AddTimeMenu = ({ facilities, onSuccess, compact, defaultFacilityId }) => {
  const classes = useStyles()
  const buttonRef = useRef(null)
  const [menuOpen, setMenuOpen] = useState(false)
  const [openTimeOpen, setOpenTimeOpen] = useState(false)
  const [blockedTimeOpen, setBlockedTimeOpen] = useState(false)

  const handleSelect = type => () => {
    setMenuOpen(false)
    if (type === 'open') setOpenTimeOpen(true)
    if (type === 'block') setBlockedTimeOpen(true)
  }

  return (
    <>
      {compact ? (
        <IconButton
          ref={buttonRef}
          color="primary"
          aria-label="Add time"
          title="Add time"
          onClick={() => setMenuOpen(true)}
        >
          <AddOutlinedIcon />
        </IconButton>
      ) : (
        <Button
          ref={buttonRef}
          variant="contained"
          color="primary"
          startIcon={<AddOutlinedIcon />}
          endIcon={<ArrowDropDownIcon />}
          style={{ whiteSpace: 'nowrap' }}
          onClick={() => setMenuOpen(true)}
        >
          Add Time
        </Button>
      )}
      <Menu
        anchorEl={buttonRef.current}
        open={menuOpen}
        onClose={() => setMenuOpen(false)}
        getContentAnchorEl={null}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
        transformOrigin={{ vertical: 'top', horizontal: 'right' }}
        classes={{ paper: classes.menuPaper }}
      >
        <MenuItem className={classes.item} onClick={handleSelect('open')}>
          <span className={`${classes.dot} ${classes.dotOpen}`} aria-hidden />
          <Box className={classes.itemText}>
            <Typography variant="body2" className={classes.itemTitle}>
              Open Time
            </Typography>
            <Typography className={classes.itemSubtitle}>
              Bookable — one-time hours on a specific day
            </Typography>
          </Box>
        </MenuItem>
        <MenuItem className={classes.item} onClick={handleSelect('block')}>
          <span
            className={`${classes.dot} ${classes.dotBlocked}`}
            aria-hidden
          />
          <Box className={classes.itemText}>
            <Typography variant="body2" className={classes.itemTitle}>
              Blocked Time
            </Typography>
            <Typography className={classes.itemSubtitle}>
              Not bookable — vacation, time off, or commitments
            </Typography>
          </Box>
        </MenuItem>
      </Menu>
      <OneTimeSlotDialog
        facilities={facilities}
        onSuccess={onSuccess}
        triggerless
        isOpen={openTimeOpen}
        onClose={() => setOpenTimeOpen(false)}
        initialType="open"
        defaultFacilityId={defaultFacilityId}
      />
      <OneTimeSlotDialog
        facilities={facilities}
        onSuccess={onSuccess}
        triggerless
        isOpen={blockedTimeOpen}
        onClose={() => setBlockedTimeOpen(false)}
        initialType="block"
        defaultFacilityId={defaultFacilityId}
      />
    </>
  )
}

export default AddTimeMenu
